<template>
  <div class="printen-en-meer-image">
    <contact-map class="map" @select-vestiging="selectVestiging"></contact-map>
    <!--  <img class="map" src="@/images/pages/kaart-met-vestigingen.svg" /> -->
    <div class="badge ben">
      <img  class="" src="@/images/pages/ben.svg" />
    </div>
    <div class="badge slider">
      <img  class="" src="@/images/pages/slider.svg" />
    </div>
    <div class="badge car">
      <img  src="@/images/pages/car.svg" />
    </div>
    <div class="badge oorkonde">
      <img  class="" src="@/images/pages/oorkonde.svg" />
    </div>
  </div>
</template>

<script>
import ContactMap from './ContactMap.vue'
export default {
  components: { ContactMap },
  methods: {
    selectVestiging(shop) {
      this.$router.push({
        name: 'contact',
        params: {
          contactShop: shop
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.printen-en-meer-image {
  display: inline-block;
  max-width: 415px;
  width: 100%;
  height: 395px;
  position: relative;
  transform: scale(0.7);

  .map {
    width: 264px !important;
    position: absolute;
    left: 74px;
    top: 0;
  }

  .badge {
    border-radius: 50%;
    background-color: white;
    overflow: hidden;
    position: absolute;
    box-shadow: rgba(0, 0, 0, 1) 0 0 47px -27px;
    animation: bounce-in 0.4s both ease-in-out;

    svg {
      position: absolute;
    }
  }

  .ben {
    width: 77px;
    height: 77px;
    left: 35px;
    top: 117px;
    animation-delay: 0.2s;

    svg {
      width: 67px;
      bottom: 0;
      left: 5px;
    }
  }

  .slider {
    width: 94px;
    height: 94px;
    left: 17px;
    top: 222px;
    animation-delay: 0.3s;

    svg {
      width: 73px;
      top: 28px;
      left: 11px;
    }
  }

  .car {
    width: 130px;
    height: 130px;
    left: 141px;
    top: 250px;
    animation-delay: 0.4s;

    svg {
      top: 44px;
      left: 7px;
    }
  }

  .oorkonde {
    width: 94px;
    height: 94px;
    left: 297px;
    top: 210px;
    animation-delay: 0.5s;

    svg {
      top: 17px;
      left: 23px;
    }
  }

  @media only screen and (min-width: 768px) {
    transform: scale(1);
  }
}

@keyframes bounce-in {
  0% {
    opacity: 1;
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}
</style>
